// extracted by mini-css-extract-plugin
export default {"NoPurchaseWrap":"notFound_NoPurchaseWrap__X6MrE","NoPurchase":"notFound_NoPurchase__S6Jy2","MyReqest":"notFound_MyReqest__gpfho","ResetBtn":"notFound_ResetBtn__LBHdD"};